// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-modal-info {
  height: 100vh;
  position: relative;
  background: #faf7f6;
}

#ADD_ON_MAIN .option-group-description {
  color: var(--ion-color-primary);
}

.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
}
@media (max-width: 992px) {
  .slide-col .image-full-screen {
    display: none;
  }
}
@media (min-width: 991px) {
  .slide-col {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row-reverse;
  }
  .slide-col .image-full-screen {
    width: 55%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slide-col .image-full-screen .image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-self: center;
    justify-content: center;
  }
  .slide-col .image-full-screen .image-wrapper .block-item {
    display: flex;
    align-self: center;
    justify-content: center;
    width: -moz-fit-content;
    width: fit-content;
    min-width: 80%;
  }
  .slide-col .image-full-screen .image-wrapper .main-img {
    width: 50% !important;
    height: 50% !important;
  }
  .slide-col .image-full-screen .image-wrapper .main-img.is-own-bowl {
    width: 80% !important;
    height: 80% !important;
  }
  .slide-col .left-part-desktop {
    width: 45%;
    border-right: 1px solid var(--color-black);
  }
}

.back_btn_close {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 24px;
  height: 24px;
  padding: 0px;
  z-index: 99;
  cursor: pointer;
}
.back_btn_close ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.header-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  padding-bottom: 0px;
  align-items: center;
}
.header-wrapper .back_btn {
  width: 30px;
  height: 30px;
}
@media (min-width: 991px) {
  .header-wrapper .back_btn {
    display: none;
  }
}

.option-group-col {
  flex-grow: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 20px;
}
.option-group-col.hidden {
  max-height: 0px;
  display: none;
}

.last-item {
  height: 75px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-img {
  position: absolute;
  top: 30px;
  left: 30px;
}

.image-wrapper {
  position: relative;
}
@media (min-width: 991px) {
  .image-wrapper {
    display: none;
  }
}
.image-wrapper .back_icon {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
  zoom: 1.5;
}
.image-wrapper .cross_icon {
  z-index: 99;
  position: absolute;
  right: 10px;
  top: 10px;
  zoom: 1.5;
}

.main-img {
  height: 15vh;
  width: 100%;
  margin: 0 auto 0px;
}
@media (max-width: 992px) {
  .main-img {
    height: 33vh;
  }
}

.default-img {
  height: 15vh;
  width: 100px !important;
}

.info {
  padding: 20px 20px 0px 20px;
}
.info .title {
  text-align: center;
  font-size: 18px;
  line-height: var(--modal-info-title-line-height);
  margin-bottom: 6px;
  padding-top: 10px;
  color: var(--color-black-alt);
  text-transform: uppercase;
}
@media (min-width: 991px) {
  .info .title {
    font-size: 25px;
  }
}
.info .title .info_block {
  font-size: 17px;
  margin-left: 5px;
  cursor: pointer;
}
.info .desc {
  text-align: center;
  font-size: var(--modal-info-desc-font-size);
  font-family: AppFont, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--color-black);
  text-transform: uppercase;
}
.info .ingrediants-section {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
  align-items: center;
  width: 100%;
}
.info .ingrediants-section h3 {
  text-align: left;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-secondary);
}
.info .ingrediants-section p {
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-primary);
  text-decoration: underline;
}
@media (max-width: 992px) {
  .info .ingrediants-section p {
    width: 50%;
    text-align: right;
  }
}

.menge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 20px 20px;
}
.menge h5 {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  text-transform: uppercase;
}

ion-button {
  position: relative;
}
ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--color-black);
  font-family: AppFont, sans-serif;
  margin-right: 0;
}
ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}

ion-toolbar {
  height: 60px;
  display: flex;
  align-items: center;
  --background: var(--background-color);
}
ion-toolbar ion-title {
  font-weight: 100;
  padding-inline: unset !important;
  font-size: 16px;
  text-align: left;
  margin-left: 40px;
  font-family: AppFontBold, sans-serif;
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  padding: 8px;
  font-size: 15px;
}

.option-group-description {
  line-height: 95%;
  padding: 10px 25px 0px 20px;
  color: var(--color-black);
  font-size: 16px;
  text-align: left;
  font-family: AppFont, sans-serif;
  font-weight: bold;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  width: 100% !important;
}

ion-page {
  background: transparent;
}

.slider-select-half {
  height: 100%;
  width: 100%;
}

.separator {
  height: 14px;
  width: 100%;
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator {
    height: 11px;
  }
}

.allergens {
  margin: 5px 20px;
}
.allergens app-accordion-list {
  width: 100%;
}

.padding-block {
  padding: 0px 20px;
}

.vertical-line {
  content: " ";
  width: 1px;
  height: 20px;
  color: white;
  background: white;
  margin-inline: 10px;
}

.add-background {
  background-size: cover;
}

.button-footer-block {
  margin: 0px !important;
  background: var(--default-background) !important;
  padding: 20px 15px 15px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
  align-items: center;
  font-size: 14px;
}
.button-footer-block:after {
  content: "";
  position: absolute;
  height: 1px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  background: var(--color-black);
}
.button-footer-block .add-to-basket {
  width: 100%;
  color: var(--color-black);
  --border-radius: 24px;
  --background: var(--default-background);
  margin-bottom: 15px;
  border: 1px solid var(--color-black);
}
.button-footer-block .add-to-basket:hover {
  --background: #f5faff;
}
.button-footer-block .button-checkout {
  display: flex;
  align-items: center;
  height: 44px;
  justify-content: center;
}
.button-footer-block .button-checkout.disabled {
  opacity: 0.5;
}
.button-footer-block .button-checkout div {
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  border: 1px solid var(--ion-color-primary);
}
@media (min-width: 991px) {
  .button-footer-block .button-checkout div {
    justify-content: center;
  }
}
.button-footer-block .button-checkout__left {
  width: 25%;
  height: 100%;
  border-bottom-left-radius: 26px;
  border-top-left-radius: 26px;
  color: #001e78;
}
.button-footer-block .button-checkout__right {
  background: var(--ion-color-primary);
  border-bottom-right-radius: 26px;
  border-top-right-radius: 26px;
  text-align: center;
  width: 75%;
  justify-content: center;
  color: var(--color-white);
  height: 100%;
}

.style-block {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 160px;
}

@keyframes pulseColor {
  0% {
    color: var(--ion-color-primary);
  }
  30% {
    color: var(--color-black);
  }
  60% {
    color: var(--ion-color-primary);
  }
  100% {
    color: var(--color-black);
  }
}
.show-option-groups {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
}
.show-option-groups h1 {
  text-transform: uppercase;
  padding: 10px 20px;
}
.show-option-groups.error-item h1 {
  color: var(--color-black);
  animation: pulseColor 4s infinite alternate;
  text-transform: uppercase;
}
.show-option-groups ion-icon {
  transition: rotate 0.3s ease-in-out;
  margin-right: 20px;
  width: 24px;
  height: 24px;
}
.show-option-groups ion-icon.isOpen {
  rotate: 180deg;
}

.delete-option {
  position: absolute;
  bottom: -1px;
  right: 0%;
  z-index: 99;
  color: black;
  background: white;
  border-top-left-radius: 15px;
  text-align: center;
  padding: 7px;
  border-top: 2px dotted black;
  border-left: 2px dotted black;
}
.delete-option p {
  font-size: 13px;
  font-family: "AppFontBold";
  text-transform: uppercase;
  color: var(--ion-color-primary);
}

.vegan-block {
  display: flex;
  align-items: center;
}
.vegan-block ion-img {
  width: 35px;
  height: 24px;
}
.vegan-block p {
  text-transform: capitalize;
  margin-right: 5px;
  font-size: 12px;
  color: var(--ion-color-secondary);
}

.input-notes {
  padding: 20px;
  border-top: 1px solid var(--color-black);
}
.input-notes ion-item {
  border: 0.5px solid var(--color-black);
  border-radius: 26px;
  --background: #f6f1ef;
  margin-bottom: 10px;
  margin-top: 10px;
}
.input-notes .container {
  position: relative;
}
.input-notes .container ion-label {
  font-family: AppFont, sans-serif;
  font-weight: bold;
  font-size: 14px;
  padding: 0px 10px 10px 10px;
  color: var(--color-black);
}

.filters {
  width: 100%;
}
.filters app-menu-list-filters {
  width: 100%;
}

@media (max-width: 992px) {
  .text-block {
    margin-bottom: auto;
    margin-top: auto;
  }
}

.price-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.price-row .price {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall {
  position: relative;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall,
.price-row .tags {
  position: relative;
  height: 17px;
  margin-left: 12px;
}
.price-row .kcall::before,
.price-row .tags::before {
  content: "";
  position: absolute;
  left: -6px;
  width: 1.5px;
  height: 100%;
  background: var(--color-black);
}

ion-textarea.custom {
  font-family: AppFont, sans-serif;
  color: var(--color-black);
  --border-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,kBAAA;EACA,mBAAA;AADD;;AAKC;EACC,+BAAA;AAFF;;AAMA;EACC,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;AAHD;ACXE;EDgBA;IACC,aAAA;EAFD;AACF;ACtBE;EDaF;IAcE,aAAA;IACA,8BAAA;IACA,iBAAA;IACA,2BAAA;EADA;EAEA;IACC,UAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EAAD;EACC;IACC,WAAA;IACA,YAAA;IACA,aAAA;IAEA,kBAAA;IACA,uBAAA;EAAF;EACE;IACC,aAAA;IACA,kBAAA;IACA,uBAAA;IAEA,uBAAA;IAAA,kBAAA;IACA,cAAA;EAAH;EAEE;IACC,qBAAA;IACA,sBAAA;EAAH;EACG;IACC,qBAAA;IACA,sBAAA;EACJ;EAIA;IACC,UAAA;IACA,0CAAA;EAFD;AACF;;AAKA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAFD;AAGC;EACC,WAAA;EACA,YAAA;EACA,WAAA;AADF;AAKA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAHD;AAIC;EACC,WAAA;EACA,YAAA;AAFF;AC7FE;ED6FD;IAIE,aAAA;EAAD;AACF;;AAGA;EACC,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAAD;AACC;EACC,eAAA;EACA,aAAA;AACF;;AAEA;EACC,YAAA;AACD;;AAEA;EACC,YAAA;EACA,cAAA;AACD;;AAEA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;AACD;;AACA;EAKC,kBAAA;AAFD;ACjIE;ED8HF;IAEE,aAAA;EAKA;AACF;AAFC;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AAIF;AAFC;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AAIF;;AADA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAID;ACpJE;ED6IF;IAME,YAAA;EAKA;AACF;;AACA;EACC,YAAA;EACA,uBAAA;AAED;;AAAA;EACC,2BAAA;AAGD;AAFC;EACC,kBAAA;EACA,eAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;AAIF;ACjLE;EDsKD;IASE,eAAA;EAMD;AACF;AALE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;AAOH;AAHC;EACC,kBAAA;EACA,2CAAA;EACA,gCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;AAIF;AAFC;EACC,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAIF;AAHE;EACC,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,iCAAA;AAIH;AAFE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;AAGH;ACvNE;ED2MA;IAWE,UAAA;IACA,iBAAA;EAKF;AACF;;AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EAMA,qBAAA;AAFD;AAHC;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;AAKF;;AAAA;EACC,kBAAA;AAGD;AADC;EACC,6CAAA;EACA,yBAAA;EACA,gCAAA;EACA,eAAA;AAGF;AADC;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAGF;;AACA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;AAED;AADC;EACC,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AAGF;AADC;EACC,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AAGF;AAAC;EACC,YAAA;EACA,eAAA;AAEF;;AACA;EACC,gBAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iBAAA;AAED;;AAAA;EACC,sBAAA;EACA,uBAAA;AAGD;;AAAA;EACC,sBAAA;AAGD;;AADA;EACC,uBAAA;AAID;;AAFA;EACC,YAAA;EACA,WAAA;AAKD;;AAHA;EACC,YAAA;EACA,WAAA;AAMD;AAFE;EANF;IAOG,YAAA;EAKD;AACF;;AAFA;EACC,gBAAA;AAKD;AAJC;EACC,WAAA;AAMF;;AAHA;EACC,iBAAA;AAMD;;AAJA;EACC,YAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAOD;;AALA;EAEC,sBAAA;AAOD;;AALA;EACC,sBAAA;EACA,gDAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAQD;AAPC;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,8BAAA;AASF;AANC;EACC,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,uCAAA;EACA,mBAAA;EAIA,oCAAA;AAKF;AARE;EACC,qBAAA;AAUH;AALC;EACC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AAOF;AAFE;EACC,YAAA;AAIH;AAFE;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;EACA,0CAAA;AAIH;ACzYE;ED+XA;IAQE,uBAAA;EAMF;AACF;AAJE;EACC,UAAA;EACA,YAAA;EAEA,+BAAA;EACA,4BAAA;EACA,cAAA;AAKH;AAHE;EACC,oCAAA;EACA,gCAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAKH;;AAYA;EACC,YAAA;EACA,gBAAA;EACA,qBAAA;AATD;;AAYA;EACC;IACC,+BAAA;EATA;EAWD;IACC,yBAAA;EATA;EAWD;IACC,+BAAA;EATA;EAWD;IACC,yBAAA;EATA;AACF;AAWA;EACC,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AATD;AAUC;EACC,yBAAA;EACA,kBAAA;AARF;AAWE;EACC,yBAAA;EACA,2CAAA;EACA,yBAAA;AATH;AAYC;EACC,mCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAVF;AAWE;EACC,cAAA;AATH;;AAaA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;AAVD;AAWC;EACC,eAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;AATF;;AAYA;EACC,aAAA;EACA,mBAAA;AATD;AAUC;EACC,WAAA;EACA,YAAA;AARF;AAUC;EACC,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,iCAAA;AARF;;AAWA;EACC,aAAA;EACA,wCAAA;AARD;AASC;EACC,sCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AAPF;AASC;EACC,kBAAA;AAPF;AAQE;EACC,gCAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;AANH;;AAUA;EACC,WAAA;AAPD;AAQC;EACC,WAAA;AANF;;ACtgBE;ED+gBF;IAEE,mBAAA;IACA,gBAAA;EANA;AACF;;AAQA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mBAAA;AAND;AAQC;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AANF;AASC;EACC,kBAAA;EAEA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AARF;AAUC;;EAEC,kBAAA;EACA,YAAA;EACA,iBAAA;AARF;AAWC;;EAEC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AATF;;AAYA;EACC,gCAAA;EACA,yBAAA;EACA,iBAAA;AATD","sourcesContent":["@import '../../../theme/mixins';\n\napp-modal-info {\n\theight: 100vh;\n\tposition: relative;\n\tbackground: #faf7f6;\n}\n\n#ADD_ON_MAIN {\n\t.option-group-description {\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\n.slide-col {\n\ttop: 0;\n\tbottom: 0;\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-size: 100% 30vh !important;\n\toverflow: auto;\n\t@include mobile {\n\t\t.image-full-screen {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: nowrap;\n\t\tflex-direction: row-reverse;\n\t\t.image-full-screen {\n\t\t\twidth: 55%;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t.image-wrapper {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\t// flex-direction: column;\n\t\t\t\talign-self: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t.block-item {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-self: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t// width: 100%;\n\t\t\t\t\twidth: fit-content;\n\t\t\t\t\tmin-width: 80%;\n\t\t\t\t}\n\t\t\t\t.main-img {\n\t\t\t\t\twidth: 50% !important;\n\t\t\t\t\theight: 50% !important;\n\t\t\t\t\t&.is-own-bowl {\n\t\t\t\t\t\twidth: 80% !important;\n\t\t\t\t\t\theight: 80% !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.left-part-desktop {\n\t\t\twidth: 45%;\n\t\t\tborder-right: 1px solid var(--color-black);\n\t\t}\n\t}\n}\n.back_btn_close {\n\tposition: absolute;\n\ttop: 15px;\n\tright: 15px;\n\tmargin: 0px;\n\tbackground: var(--color-white-accent);\n\twidth: 24px;\n\theight: 24px;\n\tpadding: 0px;\n\tz-index: 99;\n\tcursor: pointer;\n\tion-icon {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmargin: 0px;\n\t}\n\t&:hover {}\n}\n.header-wrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px;\n\tpadding-bottom: 0px;\n\talign-items: center;\n\t.back_btn {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n.option-group-col {\n\tflex-grow: 1;\n\toverflow: auto;\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tpadding: 15px 20px;\n\t&.hidden {\n\t\tmax-height: 0px;\n\t\tdisplay: none;\n\t}\n}\n.last-item {\n\theight: 75px;\n}\n\n.grow {\n\tflex-grow: 1;\n\toverflow: auto;\n}\n\n.back-img {\n\tposition: absolute;\n\ttop: 30px;\n\tleft: 30px;\n}\n.image-wrapper {\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n\t// background: black url('../../../assets/losteria/modal-info.png') no-repeat center center / 100% 100%;\n\tposition: relative;\n\t.back_icon {\n\t\tposition: absolute;\n\t\tleft: 10px;\n\t\ttop: 10px;\n\t\tz-index: 99;\n\t\tzoom: 1.5;\n\t}\n\t.cross_icon {\n\t\tz-index: 99;\n\t\tposition: absolute;\n\t\tright: 10px;\n\t\ttop: 10px;\n\t\tzoom: 1.5;\n\t}\n}\n.main-img {\n\theight: 15vh;\n\twidth: 100%;\n\tmargin: 0 auto 0px;\n\n\t@include mobile {\n\t\theight: 33vh;\n\t}\n\n\t// &.full-width {\n\t//   object-fit: cover;\n\t// }\n}\n.default-img {\n\theight: 15vh;\n\twidth: 100px !important;\n}\n.info {\n\tpadding: 20px 20px 0px 20px;\n\t.title {\n\t\ttext-align: center;\n\t\tfont-size: 18px;\n\t\tline-height: var(--modal-info-title-line-height);\n\t\tmargin-bottom: 6px;\n\t\tpadding-top: 10px;\n\t\tcolor: var(--color-black-alt);\n\t\ttext-transform: uppercase;\n\t\t@include desktop {\n\t\t\tfont-size: 25px;\n\t\t}\n\t\t.info_block {\n\t\t\tfont-size: 17px;\n\t\t\tmargin-left: 5px;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t.desc {\n\t\ttext-align: center;\n\t\tfont-size: var(--modal-info-desc-font-size);\n\t\tfont-family: AppFont, sans-serif;\n\n\t\tline-height: var(--modal-info-desc-line-height);\n\t\tpadding-bottom: 10px;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t}\n\t.ingrediants-section {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tpadding: 10px 0px;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\th3 {\n\t\t\ttext-align: left;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\n\t\t\tline-height: var(--modal-info-desc-line-height);\n\t\t\tpadding-bottom: 10px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\tp {\n\t\t\tcursor: pointer;\n\t\t\ttext-align: left;\n\t\t\tfont-size: 16px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\n\t\t\tline-height: var(--modal-info-desc-line-height);\n\t\t\tpadding-bottom: 10px;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\ttext-decoration: underline;\n\t\t\t@include mobile {\n\t\t\t\twidth: 50%;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.menge {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\th5 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 18px;\n\t\ttext-transform: uppercase;\n\t}\n\tmargin: 0px 20px 20px;\n}\n\nion-button {\n\tposition: relative;\n\n\t.buuton-text {\n\t\tfont-size: var(--modal-info-button-font-size);\n\t\tcolor: var(--color-black);\n\t\tfont-family: AppFont, sans-serif;\n\t\tmargin-right: 0;\n\t}\n\t.button-icon {\n\t\tposition: absolute;\n\t\tright: 5px;\n\t\theight: 34px;\n\t\twidth: 34px;\n\t}\n}\n\nion-toolbar {\n\theight: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\t--background: var(--background-color);\n\tion-title {\n\t\tfont-weight: 100;\n\t\tpadding-inline: unset !important;\n\t\tfont-size: 16px;\n\t\ttext-align: left;\n\t\tmargin-left: 40px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n\tion-button {\n\t\t--background: transparent;\n\t\t--background-activated: transparent;\n\t\t--background-focused: transparent;\n\t\t--background-hover: transparent;\n\t}\n\n\tion-icon {\n\t\tpadding: 8px;\n\t\tfont-size: 15px;\n\t}\n}\n.option-group-description {\n\tline-height: 95%;\n\tpadding: 10px 25px 0px 20px;\n\tcolor: var(--color-black);\n\tfont-size: 16px;\n\ttext-align: left;\n\tfont-family: AppFont, sans-serif;\n\tfont-weight: bold;\n}\nswiper-container {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\twidth: 100% !important;\n}\nion-page {\n\tbackground: transparent;\n}\n.slider-select-half {\n\theight: 100%;\n\twidth: 100%;\n}\n.separator {\n\theight: 14px;\n\twidth: 100%;\n\t// background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n\t@include desktop {\n\t\t// background: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 130%;\n\t\t@media (max-height: 750px) {\n\t\t\theight: 11px;\n\t\t}\n\t}\n}\n.allergens {\n\tmargin: 5px 20px;\n\tapp-accordion-list {\n\t\twidth: 100%;\n\t}\n}\n.padding-block {\n\tpadding: 0px 20px;\n}\n.vertical-line {\n\tcontent: ' ';\n\twidth: 1px;\n\theight: 20px;\n\tcolor: white;\n\tbackground: white;\n\tmargin-inline: 10px;\n}\n.add-background {\n\t// background: black url(../../../assets/background/background.png)  no-repeat center center / 100% 100% !important;\n\tbackground-size: cover;\n}\n.button-footer-block {\n\tmargin: 0px !important;\n\tbackground: var(--default-background) !important;\n\tpadding: 20px 15px 15px;\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\tz-index: 999;\n\talign-items: center;\n\tfont-size: 14px;\n\t&:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\theight: 1px;\n\t\ttop: 0;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\twidth: 100%;\n\t\tbackground: var(--color-black);\n\t}\n\n\t.add-to-basket {\n\t\twidth: 100%;\n\t\tcolor: var(--color-black);\n\t\t--border-radius: 24px;\n\t\t--background: var(--default-background);\n\t\tmargin-bottom: 15px;\n\t\t&:hover {\n\t\t\t--background: #f5faff;\n\t\t}\n\t\tborder: 1px solid var(--color-black);\n\t}\n\n\t.button-checkout {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 44px;\n\t\tjustify-content: center;\n\n\t\t&:hover {\n\t\t\t// background: #f2dbd9;\n\t\t}\n\t\t&.disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t\tdiv {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tpadding: 0 10px;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tborder: 1px solid var(--ion-color-primary);\n\t\t\t@include desktop {\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t}\n\t\t&__left {\n\t\t\twidth: 25%;\n\t\t\theight: 100%;\n\n\t\t\tborder-bottom-left-radius: 26px;\n\t\t\tborder-top-left-radius: 26px;\n\t\t\tcolor: #001e78;\n\t\t}\n\t\t&__right {\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tborder-bottom-right-radius: 26px;\n\t\t\tborder-top-right-radius: 26px;\n\t\t\ttext-align: center;\n\t\t\twidth: 75%;\n\t\t\tjustify-content: center;\n\t\t\tcolor: var(--color-white);\n\t\t\theight: 100%;\n\t\t}\n\n\t\t//.right-checkout {\n\t\t//    cursor: pointer;\n\t\t//    padding: 0px 15px 0px 10px;\n\t\t//    p {\n\t\t//        color: var(--color-black);\n\t\t//        font-family: AppFontMedium;\n\t\t//        text-align: center;\n\t\t//    }\n\t\t//    text-transform: uppercase;\n\t\t//    text-align: center;\n\t\t//}\n\t}\n}\n\n.style-block {\n\theight: 100%;\n\toverflow-y: auto;\n\tpadding-bottom: 160px;\n\t// padding-bottom: calc(9 / 16 * 100%);\n}\n@keyframes pulseColor {\n\t0% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\t30% {\n\t\tcolor: var(--color-black);\n\t}\n\t60% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\t100% {\n\t\tcolor: var(--color-black);\n\t}\n}\n.show-option-groups {\n\tdisplay: flex;\n\tcursor: pointer;\n\talign-items: center;\n\tjustify-content: space-between;\n\th1 {\n\t\ttext-transform: uppercase;\n\t\tpadding: 10px 20px;\n\t}\n\t&.error-item {\n\t\th1 {\n\t\t\tcolor: var(--color-black);\n\t\t\tanimation: pulseColor 4s infinite alternate;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n\tion-icon {\n\t\ttransition: rotate 0.3s ease-in-out;\n\t\tmargin-right: 20px;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\t&.isOpen {\n\t\t\trotate: 180deg;\n\t\t}\n\t}\n}\n.delete-option {\n\tposition: absolute;\n\tbottom: -1px;\n\tright: 0%;\n\tz-index: 99;\n\tcolor: black;\n\tbackground: white;\n\tborder-top-left-radius: 15px;\n\ttext-align: center;\n\tpadding: 7px;\n\tborder-top: 2px dotted black;\n\tborder-left: 2px dotted black;\n\tp {\n\t\tfont-size: 13px;\n\t\tfont-family: 'AppFontBold';\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n.vegan-block {\n\tdisplay: flex;\n\talign-items: center;\n\tion-img {\n\t\twidth: 35px;\n\t\theight: 24px;\n\t}\n\tp {\n\t\ttext-transform: capitalize;\n\t\tmargin-right: 5px;\n\t\tfont-size: 12px;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n}\n.input-notes {\n\tpadding: 20px;\n\tborder-top: 1px solid var(--color-black);\n\tion-item {\n\t\tborder: 0.5px solid var(--color-black);\n\t\tborder-radius: 26px;\n\t\t--background: #f6f1ef;\n\t\tmargin-bottom: 10px;\n\t\tmargin-top: 10px;\n\t}\n\t.container {\n\t\tposition: relative;\n\t\tion-label {\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-weight: bold;\n\t\t\tfont-size: 14px;\n\t\t\tpadding: 0px 10px 10px 10px;\n\t\t\tcolor: var(--color-black);\n\t\t}\n\t}\n}\n.filters {\n\twidth: 100%;\n\tapp-menu-list-filters {\n\t\twidth: 100%;\n\t}\n}\n.text-block {\n\t@include mobile {\n\t\tmargin-bottom: auto;\n\t\tmargin-top: auto;\n\t}\n}\n.price-row {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tmargin-bottom: 20px;\n\n\t.price {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 16.8px;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.kcall {\n\t\tposition: relative;\n\n\t\tfont-size: 14px;\n\t\tline-height: 16.8px;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t}\n\t.kcall,\n\t.tags {\n\t\tposition: relative;\n\t\theight: 17px;\n\t\tmargin-left: 12px;\n\t}\n\n\t.kcall::before,\n\t.tags::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: -6px;\n\t\twidth: 1.5px;\n\t\theight: 100%;\n\t\tbackground: var(--color-black);\n\t}\n}\nion-textarea.custom {\n\tfont-family: AppFont, sans-serif;\n\tcolor: var(--color-black);\n\t--border-width: 0;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
